import { Button } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
/**
 * 
 * @param {{handleRefresh: () => void, loading: boolean}} param
 * @returns 
 */
const RefreshButtonTable = ({ handleRefresh, loading }) => {
    return (
        <div className="d-flex justify-content-end mb-2">
            <Button
                variant="outline-primary"
                size="sm"
                onClick={handleRefresh}
                disabled={loading}
                className="d-flex align-items-center gap-2"
            >
                <Spinner animation="border" size="sm" className={loading ? "" : "d-none"} />
                <i className={`bi bi-arrow-clockwise ${loading ? "d-none" : ""}`}></i>
                Refresh
            </Button>
        </div>

    );
};

export default RefreshButtonTable;